import axios from 'axios'
axios.defaults.baseURL = process.env.BASE_URL
axios.defaults.withCredentials = true


export default {

    getToken() { //获取token
        return axios.get('index/winebefore/token_fac')
    },

    getMeetingList(data) {// 会议议程列表
        return axios.get('index/winebefore/notice', {
            params: {
                ...data
            }
        })
    },
    getNewsList(data){ //新闻列表
        return axios.get('index/winebefore/news', {
            params: {
                ...data
            }
        })
    },
    getNewsDetail(data){ //新闻详情
        return axios.get('index/winebefore/newsShow', {
            params: {
                ...data
            }
        })
    },
    getNotice(data) { // 联系我们
        return axios.get('index/winebefore/notice', {
            params: {
                ...data
            }
        })
    },
    getLibraryList(data) {// 醉美泸州类型列表
        return axios.get('index/wine/material', {
            params: {
                ...data
            }
        })
    },
    getMaterialList(data) { // 醉美泸州素材列表
        return axios.get('index/wine/getMaterialList', {
            params: {
                ...data
            }
        })
    },
    getMaterialdetail(data) { // 醉美泸州素材详情
        return axios.get('index/wine/material', {
            params: {
                ...data
            }
        })
    },
    metarialToEmial(data){ // 醉美泸州素材发送至邮箱
        return axios.get('index/wine/mail', {
            params: {
                ...data
            }
        })
    },
    
    getUserInfo(data) { // 获取用户信息
        return axios.get('index/winebefore/all_userinfo', {
            params: {
                ...data
            }
        })
    },
    getPersonalAbout(data) { //获取个人中心——关于我们
        return axios.get('index/winebefore/notice', {
            params: {
                ...data
            }
        })
    },
    login(data) {
        return axios.get('index/winebefore/login', {
            params: {
                ...data
            }
        })
    },
    logout(data) {
        return axios.get('index/winebefore/cancel_login', {
            params: {
                ...data
            }
        })
    },
    getCode(data) { // 获取手机验证
        return axios.get('index/winebefore/message', {
            params: {
                ...data
            }
        })
    },


    getShareData(data){
        return axios.get('index/winebefore/share', {
            params: {
                ...data
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/axiosApi.js